export enum InitialSearchState {
  NOT_STARTED,
  DONE,
}

export const DEFAULT_MILES_RADIUS = 50;

export const DEFAULT_ADDRESS = '601 Biscayne Blvd, Miami, FL 33132, USA';
